import FormRule from "../../FormRule.model";

export default class SecurityRule extends FormRule {
    constructor(manager, settings = {}) {
        super(manager, settings);
    }

    /**
     * Apply security process before submit form. Must be overrided.
     * @return {Promise<boolean>}
     */
    async apply() {
        return  true;
    }
}